export const enum AgentAvatarTypeEnum {
  default = 'default',
  superAgent = 'super-agent',
}
